import { useEffect, useState, useRef } from 'react'; 
// import Skeleton from '@mui/material/Skeleton';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
// import _ from 'lodash'; 
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createTheme, ThemeProvider, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthRounded';

const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiInputBase-input": {
              fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: '500'
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            width: 'max-content',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            "&.MuiTypography-root": {
              fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: '400'
            },
          },
        },
      },
    },
});

const DynamicTableInputCopy = ({count, length, data, setData, config, showError=false, args, width, font, onChangeFunction=()=>{return} }) => {
    // initialize ref
    const ref = useRef();
    // initialize state 
    const [value, setValue] = useState({label: '--select--', id: '--select--'}); 

    // set width if not given as prop
    if (width == null){
        width = '16.6vw';
    } 
    // set font size if given as prop, else use default
    let style = {};
    if (font){
        style['fontSize'] = font;
    } 

    // event handler for input change
    const onChange = (e) => {
        // set render state 
        setValue(value => value = e.target.value)
        // set data prop
        let temp = data; 
        temp[count][config['columnid']] = e.target.value; 
        setData(data => data = temp); 
        console.log(temp); 
        // run onChangeFunction 
        onChangeFunction(); 
    }

    // event handler for input change
    const onAutocompleteChange = (e, values) => {
        // set render state 
        setValue(value => value = values)
        // set data prop
        let temp = data; 
        temp[count][config['columnid']] = values; 
        setData(data => data = temp); 
        console.log(temp); 
        // run onChangeFunction 
        onChangeFunction(); 
    }

    // event handler for date change
    const onDateChange = (newVal) => {
        setValue(value => value = newVal ); 
        // set data prop
        let temp = data; 
        temp[count][config['columnid']] = newVal; 
        setData(data => data = temp); 
        console.log(temp); 
        // run onChangeFunction 
        onChangeFunction(); 
    }

    // event handler for checkbox change 
    const onCheckboxChange = (e) => {
        setValue(value => value =  e.target.checked); 
        // set data prop
        let temp = data; 
        temp[count][config['columnid']] = e.target.checked; 
        setData(data => data = temp); 
        console.log(temp); 
        // run onChangeFunction 
        onChangeFunction(); 
    }

    // -- Date disable functions -- 
    // function to diable dates greater than disable
    const disableGreater = (date, disable) => {
        // if (date == null || disable == null) {
        //     return false; 
        // }
        if (moment(date).isAfter(disable)){
            return true;
        }
        else{
            return false; 
        }
    }

    // funciton to disable dates less than disable
    const disableLessThan = (date, disable) => {
        // if (date == null || disable == null) {
        //     return false; 
        // }
        if (moment(date).isBefore(disable)){
            return true;
        }
        else{
            return false; 
        }
    }

    // function to disable all dates more than 12 months before disable
    const disableMoreThanYearBefore = (date, disable) => {
        // if (date == null || disable == null) {
        //     return false; 
        // }
        let temp = new Date(disable);
        temp.setFullYear((parseInt(temp.getFullYear()) - 1).toString());
        if (moment(date).isBefore(temp)){
            return true;
        }
        else{
            return false; 
        }
    }

    // function to disable all dates more than 12 months after disable
    const disableMoreThanYearAfter = (date, disable) => {
        // if (date == null || disable == null) {
        //     return false; 
        // } 
        let temp = new Date(disable);
        temp.setFullYear((parseInt(temp.getFullYear()) + 1).toString());
        if (moment(date).isAfter(temp)){
            return true;
        }
        else{
            return false; 
        }
    }

    // useEffect on data change 
    useEffect(() => {
        setValue(value => value = data[count][config['columnid']]);
    }, [data, length]); 

    // useEffect on config change 
    useEffect(() => {
        if (config['inputtype'] == 'input' && (value['label'] == '--select--' && value['id'] == '--select--')) {
            if (data[count][config['columnid']]) {
                console.log(data[count][config['columnid']]); 
                setValue(value => value = data[count][config['columnid']]);
            }
            else {
                setValue(value => value = '');
            }
        }
        else if (config['inputtype'] == 'input' && (value['label'] == '--select--' && value['id'] == '--select--')) {
            if (data[count][config['columnid']]) {
                console.log(data[count][config['columnid']]); 
                setValue(value => value = data[count][config['columnid']]);
            }
            else {
                setValue(value => value = null);
            }
        }
    }, [config]); 

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            console.log('CONFIG: ', config); 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // main render function 
    const renderInput = () => {
        if (config['inputtype'] == 'input') {
            // render input
            return <div className={"w-100"}>
                    {/* <Typography sx={{fontWeight:'400',fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',fontSize:'14px',lineHeight:'24px'}}>
                        {config['tag']} 
                    </Typography> */}
                    <TextField 
                        sx={{ width: width, maxWidth: width, "& .MuiInputBase-input": {
                            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: '400'
                            },
                            '& ::placeholder': {
                            fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: '400'
                        },}} 
                        id="outlined-basic" 
                        size='small' 
                        placeholder={`Enter ${config['tag']}`} 
                        variant="outlined" 
                        value={value}
                        onChange={onChange}
                        inputProps={{style: style}} // font size of input text
                        InputLabelProps={{style: style}} // font size of input labels
                        inputRef={ref} 
                        error={error}
                     />
                    </div>
        }
        else if (config['inputtype'] == 'select') {
            // set list from args object
            let list = []; 
            if (args[config['columnid']]) {
                list = args[config['columnid']]; 
            }
            // render select
            return <div className={"w-100"}>
                {/* <Typography sx={{fontWeight:'400',fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',fontSize:'14px',lineHeight:'24px'}}>
                    {config['tag']}
                </Typography> */}
                <FormControl fullWidth size='small' sx={{ width: width, maxWidth: width , "& .MuiInputBase-root": {
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "24px",
                        // backgroundColor: "white",
                        fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                    },}}>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={style} 
                        value={value}             
                        onChange={onChange}
                        inputRef={ref}
                        error={error}
                    >
                        {list.map( el =>    
                            <MenuItem 
                                sx={{"&.Mui-selected": {
                                    backgroundColor: "#E6EDF1",
                                },
                                "&.Mui-selected:focus": {
                                    backgroundColor: "#E6EDF1",
                                },
                                "&.MuiMenuItem-root": {
                                    fontSize: "14px",
                                    borderBottom: "1px solid #E6EDF1",
                                    fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                                },}}
                            style={style} id={el['id']} value={el} >{el['label']}</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </div>
        }   
        else if (config['inputtype'] == 'select_default') {
            // set list from args object
            let list = []; 
            if (args[config['columnid']]) {
                list = args[config['columnid']]; 
            }
            // render select
            return <div className={"w-100"}>
                {/* <Typography sx={{fontWeight:'400',fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',fontSize:'14px',lineHeight:'24px'}}>
                    {config['tag']}
                </Typography> */}
                <FormControl fullWidth size='small' sx={{ width: width, maxWidth: width , "& .MuiInputBase-root": {
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "24px",
                        // backgroundColor: "white",
                        fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                    },}}>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={style} 
                        value={value}            
                        onChange={onChange}
                        inputRef={ref}
                        error={error}
                    >
                        {list.map( el =>    
                            <MenuItem sx={{"&.Mui-selected": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.Mui-selected:focus": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.MuiMenuItem-root": {
                                fontSize: "14px",
                                borderBottom: "1px solid #E6EDF1",
                                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                            },}}                          
                            style={style} id={el} value={el} >{el}</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </div>
        }   
        else if (config['inputtype'] == 'autocomplete') {
            // set list from args object
            let list = []; 
            if (args[config['columnid']]) {
                list = args[config['columnid']]; 
            }
            // filter autocomplete list elements 
            const filterOptions = createFilterOptions({
                stringify: ({ label, id }) => `${label}${id}`
            });
            // return 
            return <div className={"w-100"}>
                {/* <Typography sx={{fontWeight:'400',fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',fontSize:'14px',lineHeight:'24px'}}>
                    {config['tag']}
                </Typography> */}
                <FormControl fullWidth size='small' sx={{ width: width, maxWidth: width }} >
                    <Autocomplete
                        value={value}
                        options={list}
                        renderOption={(props, option) => (
                            <MenuItem sx={{whiteSpace:"collapse","&.Mui-selected": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.Mui-selected:focus": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.MuiMenuItem-root": {
                                fontSize: "14px",
                                borderBottom: "1px solid #E6EDF1",
                                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                            },}}    
                            {...props} key={option.id}>
                            {option.label + '\n' + option.id}
                            </MenuItem>
                        )}
                        getOptionsLabel={option => option.label}
                        renderInput={params => {
                            return (
                                <TextField 
                                    sx={{ width: width, maxWidth: width, "& .MuiInputBase-input": {
                                        fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
                                        fontSize: "16px",
                                        fontWeight: '400'
                                        },
                                        '& ::placeholder': {
                                        fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
                                        fontSize: "16px",
                                        fontWeight: '400'
                                    },}} 
                                    {...params} 
                                    placeholder={`Search ${config['tag']}`} 
                                    variant="outlined" 
                                    fullWidth
                                    size='small'
                                    inputRef={ref}
                                    error={error}
                                />
                            )
                        }}
                        onChange={onAutocompleteChange}
                        disableClearable
                        filterOptions={filterOptions}
                    />
                </FormControl>
            </div>
        }
        else if (config['inputtype'] == 'autocomplete_default') {
            // set list from args object
            let list = []; 
            if (args[config['columnid']]) {
                list = args[config['columnid']]; 
            }
            // filter autocomplete list elements 
            const filterOptions = createFilterOptions({
                stringify: ({ label, id }) => `${label}${id}`
            });
            // return 
            return <div className={"w-100"}>
                    {/* <Typography sx={{fontWeight:'400',fontFamily:'Roboto regular, Helvetica, Arial, sans-serif',fontSize:'14px',lineHeight:'24px'}}>
                        {config['tag']}
                    </Typography> */}
                    <FormControl fullWidth size='small' sx={{ width: width, maxWidth: width }} >
                    <Autocomplete
                        value={value}
                        options={list}
                        renderOption={(props, option) => 
                            <MenuItem sx={{whiteSpace:"collapse","&.Mui-selected": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.Mui-selected:focus": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.MuiMenuItem-root": {
                                fontSize: "14px",
                                borderBottom: "1px solid #E6EDF1",
                                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                            },}}  
                             {...props} style={style}>{option}</MenuItem>
                        }
                        getOptionsLabel={option => option.label}
                        renderInput={params => {
                            return (
                                <TextField 
                                    sx={{ width: width, maxWidth: width, "& .MuiInputBase-input": {
                                        fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
                                        fontSize: "16px",
                                        fontWeight: '400'
                                        },
                                        '& ::placeholder': {
                                        fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
                                        fontSize: "16px",
                                        fontWeight: '400'
                                    },}} 
                                    {...params} 
                                    placeholder={`Search ${config['tag']}`} 
                                    variant="outlined" 
                                    fullWidth
                                    size='small'
                                    inputRef={ref}
                                    error={error}
                                />
                            )
                        }}
                        onChange={onAutocompleteChange}
                        disableClearable
                        filterOptions={filterOptions}
                    />
                </FormControl>
            </div>
        }
        else if (config['inputtype'] == 'date') {
            // function to disable dates
            const disableDate = (date) => {
                let configArgs = JSON.parse(config['args']); 
                // get date to disable 
                let disable = new Date(data[configArgs['disable']]); 
                // return disable function
                if (configArgs['indicator'] == 1){
                    return disableGreater (date, disable)  || disableMoreThanYearBefore (date, disable) ;
                }
                else if (configArgs['indicator'] == 2){
                    return disableLessThan (date, disable)  || disableMoreThanYearAfter (date, disable) ; 
                }
                else if (configArgs['indicator'] == 3){
                    return disableGreater (date, disable) ; 
                }
                else if (configArgs['indicator'] == 4){
                    return disableLessThan (date, disable) ; 
                }
                else {
                    return false; 
                } 
            }
            // return datepicker
            return <div className={"w-100"}>
                    <ThemeProvider theme={theme}>
                        {/* <Typography>
                            {config['tag']}
                        </Typography> */}
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                inputFormat="MM-dd-yyyy"
                                value={value}
                                shouldDisableDate={disableDate}
                                onChange={onDateChange}
                                inputProps={{style: style}}       
                                renderInput={(params) => <TextField 
                                    inputProps={{style: style}} 
                                    InputLabelProps={{style: style}} 
                                    sx={{ width: width}}
                                    size='small' {...params} 
                                />}
                                emptyLabel='None'
                                slotProps={{ textField: { size: 'small' } }}
                                slots={{ 
                                    openPickerIcon: () => <CalendarMonthIcon sx={{color: 'black'}}/>
                                }}
                                className='date-class'
                                inputRef={ref} 
                            />
                        </LocalizationProvider>
                    </ThemeProvider>
            </div>
        }
        else if (config['inputtype'] == 'date_month') {
            // function to disable dates
            const disableDate = (date) => {
                let configArgs = JSON.parse(config['args']); 
                // get date to disable 
                let disable = new Date(data[configArgs['disable']]); 
                // return disable function
                if (configArgs['indicator'] == 1){
                    return disableGreater (date, disable)  || disableMoreThanYearBefore (date, disable) ;
                }
                else if (configArgs['indicator'] == 2){
                    return disableLessThan (date, disable)  || disableMoreThanYearAfter (date, disable) ; 
                }
                else if (configArgs['indicator'] == 3){
                    return disableGreater (date, disable) ; 
                }
                else if (configArgs['indicator'] == 4){
                    return disableLessThan (date, disable) ; 
                }
                else {
                    return false; 
                } 
            }
            // return datepicker
            return <div className={"w-100"}>
                <ThemeProvider theme={theme}>
                    {/* <Typography>
                            {config['tag']}
                    </Typography> */}
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker 
                            shouldDisableDate={disableDate}
                            size = 'small'
                            value={value}
                            onChange={onDateChange}
                            inputProps={{style: style}}       
                            renderInput={(params) => <TextField InputLabelProps={{style: style}} 
                            sx={{ width: width}}  size='small' {...params} />}
                            emptyLabel='None' 
                            views={['month', 'year']} 
                            slotProps={{ textField: { size: 'small'} }}
                            slots={{ 
                                openPickerIcon: () => <CalendarMonthIcon sx={{color: 'black'}}/>
                            }}
                            className='date-class'
                            inputRef={ref} 
                        />
                    </LocalizationProvider>
                </ThemeProvider>
            </div>
        }
        else if (config['inputtype'] == 'checkbox') {
            return <FormControlLabel
                value="end"
                control={
                    <Checkbox
                        sx={{
                            color: '#000000',
                            '&.Mui-checked': {
                            color: '#000000',
                            },
                        }} 
                        inputRef={ref}
                        error={error}
                    />
                }
                label={ <Typography sx={{ fontFamily: "Roboto regular, Helvetica, Arial, sans-serif"}}>
                            {config['tag']}
                        </Typography>}
                labelPlacement="end"
                sx={{
                    color: 'black',
                }}
                checked={value}
                onChange={onCheckboxChange}
            />
        }
    }
    
    // render input 
    return (
        <>{renderInput()}</>
    ); 
}

export default DynamicTableInputCopy; 